"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monteleone-di-spoleto": {
    "4ae05569": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "skipSearch": false
    }],
    "butino": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3a7e12dd": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "skipSearch": false
    }],
    "casale-niccoli": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9f7c3c15": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "skipSearch": false
    }],
    "casale-solferino": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43fc3bc7": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "skipSearch": false
    }],
    "colle-del-capitano": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4b7a905f": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "skipSearch": false
    }],
    "la-trogna": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e43b0c48": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "skipSearch": false
    }],
    "la-villa": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2d621a7": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "skipSearch": false
    }],
    "vallatte": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18d85d91": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "skipSearch": false
    }],
    "villa-cesi": [{
      "hkey": "237f7160",
      "slug": "monteleone-di-spoleto",
      "name": "Monteleone di Spoleto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;